import { render, staticRenderFns } from "./ModalLoginIntrustCA.vue?vue&type=template&id=97a13196&scoped=true"
import script from "./ModalLoginIntrustCA.vue?vue&type=script&lang=js"
export * from "./ModalLoginIntrustCA.vue?vue&type=script&lang=js"
import style0 from "./ModalLoginIntrustCA.vue?vue&type=style&index=0&id=97a13196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a13196",
  null
  
)

export default component.exports